__turbopack_context__.v({
  "choiceDock": "krails-video-player-module__4y1WjW__choiceDock",
  "choiceDockCompact": "krails-video-player-module__4y1WjW__choiceDockCompact",
  "choiceDockInner": "krails-video-player-module__4y1WjW__choiceDockInner",
  "choiceLabel": "krails-video-player-module__4y1WjW__choiceLabel",
  "choiceSplit": "krails-video-player-module__4y1WjW__choiceSplit",
  "choiceSplitActive": "krails-video-player-module__4y1WjW__choiceSplitActive",
  "choiceTitle": "krails-video-player-module__4y1WjW__choiceTitle",
  "dockStack": "krails-video-player-module__4y1WjW__dockStack",
  "halfChoice": "krails-video-player-module__4y1WjW__halfChoice",
  "initialSplit": "krails-video-player-module__4y1WjW__initialSplit",
  "playIcon": "krails-video-player-module__4y1WjW__playIcon",
  "playWrap": "krails-video-player-module__4y1WjW__playWrap",
  "playerShell": "krails-video-player-module__4y1WjW__playerShell",
  "posterRoot": "krails-video-player-module__4y1WjW__posterRoot",
  "posterVideo": "krails-video-player-module__4y1WjW__posterVideo",
  "videoEmbed": "krails-video-player-module__4y1WjW__videoEmbed",
  "videoStagePlaying": "krails-video-player-module__4y1WjW__videoStagePlaying",
});
